import {ReactNode} from 'react';

import Business from 'src/assets/academies/topic-links/business.svg';
import Design from 'src/assets/academies/topic-links/design.svg';
import Development from 'src/assets/academies/topic-links/development.svg';
import ItAndSoftware from 'src/assets/academies/topic-links/itAndSoftware.svg';
import Marketing from 'src/assets/academies/topic-links/marketing.svg';
import TeachingAndAcademics from 'src/assets/academies/topic-links/teachingAndAcademics.svg';

const categoryIconMap: Record<number, ReactNode> = {
    268: Business,
    269: Design,
    288: Development,
    294: ItAndSoftware,
    290: Marketing,
    300: TeachingAndAcademics,
};

// TODO: Once the new icons are in the design-system, use the DS icons instead.
export const getCategoryIcon = (categoryId: number) => {
    return categoryIconMap[categoryId] ?? Development;
};
